(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-custom-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-nh-offer-link]');
    if (!link) return;
    var offer = document.getElementById('offre-nayeau');
    if (!offer) return;
    event.preventDefault();
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    offer.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  function setNayeauComparison(compare, value) {
    var nextValue = Math.max(0, Math.min(100, Math.round(value)));
    compare.style.setProperty('--nh-split', nextValue + '%');
    var range = compare.querySelector('[data-nh-compare-range]');
    if (range) range.value = String(nextValue);
  }

  document.addEventListener('input', function(event) {
    var range = event.target.closest('[data-nh-compare-range]');
    if (!range) return;
    var compare = range.closest('[data-nh-compare]');
    if (compare) setNayeauComparison(compare, range.value);
  });

  var activeNayeauMedia = null;
  var activeNayeauPointer = null;

  document.addEventListener('pointerdown', function(event) {
    var media = event.target.closest('[data-nh-compare-media]');
    if (!media || event.button !== 0) return;
    activeNayeauMedia = media;
    activeNayeauPointer = event.pointerId;
    media.setAttribute('data-nh-dragging', 'true');
    if (media.setPointerCapture) {
      try { media.setPointerCapture(event.pointerId); } catch (error) {}
    }
    var bounds = media.getBoundingClientRect();
    var compare = media.closest('[data-nh-compare]');
    if (compare && bounds.width) setNayeauComparison(compare, ((event.clientX - bounds.left) / bounds.width) * 100);
    if (event.pointerType !== 'touch') event.preventDefault();
  });

  document.addEventListener('pointermove', function(event) {
    if (!activeNayeauMedia || event.pointerId !== activeNayeauPointer) return;
    var bounds = activeNayeauMedia.getBoundingClientRect();
    var compare = activeNayeauMedia.closest('[data-nh-compare]');
    if (compare && bounds.width) setNayeauComparison(compare, ((event.clientX - bounds.left) / bounds.width) * 100);
  });

  function stopNayeauDrag(event) {
    if (!activeNayeauMedia || event.pointerId !== activeNayeauPointer) return;
    activeNayeauMedia.removeAttribute('data-nh-dragging');
    activeNayeauMedia = null;
    activeNayeauPointer = null;
  }

  document.addEventListener('pointerup', stopNayeauDrag);
  document.addEventListener('pointercancel', stopNayeauDrag);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-nayeau-lightbox-trigger]');
    if (trigger) {
      const gallery = trigger.closest('.nayeau-catalog');
      const dialog = gallery && gallery.querySelector('[data-nayeau-lightbox]');
      const image = dialog && dialog.querySelector('img');
      if (!dialog || !image) return;
      image.src = trigger.dataset.fullSrc;
      image.alt = trigger.dataset.alt || '';
      dialog.showModal();
      return;
    }

    const openDialog = event.target.closest('[data-nayeau-lightbox]');
    if (openDialog && event.target === openDialog) openDialog.close();
  });

  } catch(e) { console.error(e); }
})();
})();
